// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"27":"7fa099c262a77f9c","321":"d7130aa8fdc8b6af"}[chunkId] + ".css";
};